export enum PatchResultStatus
{
    Applied = 0,
    PatchNumberMismatch = 1,
    NotAllowed = 2,
    Error = 3
}